module.exports = __webpack_public_path__ + "img/lg_ring_y_skip_1_null@2x.abf5fcdf.png";